import { Backdrop, CircularProgress } from '@mui/material';
import { Box, styled } from '@mui/system';

const StyledLoading = styled('div')(() => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    flex: 1,
    zIndex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
        width: 'auto',
        height: '25px',
    },
    '& .circleProgress': {
        position: 'absolute',
        left: -7,
        right: 0,
        top: 'calc(50% - 25px)',
    },
}));

const LoadingModelComponent = ({ isLoading }) => {
    return (

        <div>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            // onClick={handleClose}
            >
                <Box>
                    <img src="/assets/images/logo-circle.svg" alt="" />
                    <CircularProgress className="circleProgress" />
                </Box>

            </Backdrop>
        </div>
        // <StyledLoading>

        //   <Box position="relative">
        //     <img src="/assets/images/logo-circle.svg" alt="" />
        //     <Backdrop
        //       sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        //       open={isLoading}
        //     // onClick={handleClose}
        //     >
        //       <CircularProgress color="inherit" />
        //     </Backdrop>
        //   </Box>

        // </StyledLoading>

    );
};

export default LoadingModelComponent;
